/*
 * KSV 商品写真のばらつき補正（表示時のみ。元画像は変更しない）
 * 方針：元データが基準に近い写真はそのまま。基準から大きくずれた写真だけを基準に寄せる。
 * 1. 物撮り（背景が明るく一様）：背景の色かぶり・明るさが基準色 BG から許容範囲を超えていれば、背景が BG になるよう補正
 * 2. 背景のある写真：全体が暗すぎる／明るすぎる、または白やグレーの部分に強い色かぶりがあるときだけ、控えめに補正
 * 彩度やコントラストなどの「作風」は加えない（設定で加えることもできる）。
 * 設定は window.KSV_TONE（sections/ksv-head.liquid）。
 */
(function () {
  var C = window.KSV_TONE || {};
  var SAT = C.sat != null ? C.sat : 1;
  var CON = C.con != null ? C.con : 1;
  var OFF = C.off || [0, 0, 0];
  var GAM = C.gamma || [1, 1, 1];
  var BG = C.bg || [236, 236, 234];
  var TOL_CAST = C.tolCast != null ? C.tolCast : 6;   // 背景の色かぶりの許容（R,G,Bの差・0〜255）
  var TOL_LUM = C.tolLum != null ? C.tolLum : 10;     // 背景の明るさの許容（0〜255）
  var SCENE_MIN = C.sceneMin != null ? C.sceneMin : 0.32; // 背景のある写真の明るさの下限
  var SCENE_MAX = C.sceneMax != null ? C.sceneMax : 0.74; // 同、上限
  var SCENE_CAST = C.sceneCast != null ? C.sceneCast : 0.035; // 白・グレー部分の色かぶりの許容
  var CAST = C.castFix != null ? C.castFix : 0.6;      // 色かぶりを取る強さ
  var MAX = 1.18, MIN = 0.85;
  var SELECTOR = '.ksv-card__media img, .ksv-scene__img img, .product__media-item img, .product-media-container img, .thumbnail img';

  var PRE = BG.map(function (v, i) { return (Math.pow(v / 255, 1 / GAM[i]) - OFF[i]) / CON; });
  var LW = [0.2126, 0.7152, 0.0722];
  var S = [0, 1, 2].map(function (r) {
    return [0, 1, 2].map(function (c) { return LW[c] * (1 - SAT) + (r === c ? SAT : 0); });
  });
  var GRADE = SAT !== 1 || CON !== 1 || OFF.some(function (v) { return v !== 0; }) || GAM.some(function (v) { return v !== 1; });
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  function matrix(gain) {
    var rows = [];
    for (var r = 0; r < 3; r++) {
      var row = [];
      for (var c = 0; c < 3; c++) row.push(Math.round(CON * S[r][c] * gain[c] * 10000) / 10000);
      row.push(0, Math.round(OFF[r] * 10000) / 10000);
      rows.push(row.join(' '));
    }
    rows.push('0 0 0 1 0');
    return rows.join(' ');
  }

  var cache = {};
  var ns = 'http://www.w3.org/2000/svg';
  var defs = null;

  function ensureDefs() {
    if (defs) return defs;
    defs = document.createElementNS(ns, 'svg');
    defs.setAttribute('class', 'ksv-tone');
    defs.setAttribute('aria-hidden', 'true');
    defs.setAttribute('focusable', 'false');
    document.body.appendChild(defs);
    return defs;
  }

  function baseOf(src) { return (src || '').split('?')[0]; }

  function apply(img, res) {
    if (!res && !GRADE) { img.classList.add('is-original'); return; }
    var g = res ? res.g : [1, 1, 1];
    var id = 'ksvt' + g.map(function (v) { return Math.round(v * 1000); }).join('-');
    if (!document.getElementById(id)) {
      var f = document.createElementNS(ns, 'filter');
      f.id = id;
      f.setAttribute('color-interpolation-filters', 'sRGB');
      var m = document.createElementNS(ns, 'feColorMatrix');
      m.setAttribute('type', 'matrix');
      m.setAttribute('values', matrix(g));
      f.appendChild(m);
      if (GAM.some(function (v) { return v !== 1; })) {
        var ct = document.createElementNS(ns, 'feComponentTransfer');
        ['R', 'G', 'B'].forEach(function (ch, k) {
          var fn = document.createElementNS(ns, 'feFunc' + ch);
          fn.setAttribute('type', 'gamma');
          fn.setAttribute('amplitude', '1');
          fn.setAttribute('exponent', String(GAM[k]));
          fn.setAttribute('offset', '0');
          ct.appendChild(fn);
        });
        f.appendChild(ct);
      }
      ensureDefs().appendChild(f);
    }
    img.style.filter = 'url(#' + id + ')';
    img.classList.add(res && res.kind === 'product' ? 'is-toned' : 'is-scene');
  }

  function analyze(d, W, H) {
    var m = Math.max(2, Math.round(W * 0.05));
    var s = [0, 0, 0], n = 0, sl = 0, sl2 = 0;
    var all = 0, cnt = 0, neu = [0, 0, 0], nn = 0;
    for (var y = 0; y < H; y++) {
      for (var x = 0; x < W; x++) {
        var i = (y * W + x) * 4;
        var r = d[i] / 255, g = d[i + 1] / 255, b = d[i + 2] / 255;
        var l = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        all += l; cnt++;
        var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
        if (l > 0.3 && l < 0.95 && mx - mn < 0.1) { neu[0] += r; neu[1] += g; neu[2] += b; nn++; }
        if (x < m || x >= W - m || y < m || y >= H - m) {
          s[0] += d[i]; s[1] += d[i + 1]; s[2] += d[i + 2];
          var lb = (d[i] + d[i + 1] + d[i + 2]) / 3;
          sl += lb; sl2 += lb * lb; n++;
        }
      }
    }
    var lm = sl / n;
    var sd = Math.sqrt(Math.max(0, sl2 / n - lm * lm));
    if (lm >= 185 && sd <= 22) {
      // 物撮り：基準からのずれが許容内ならそのまま
      var avg = s.map(function (v) { return v / n; });
      var cast = Math.max.apply(null, avg) - Math.min.apply(null, avg);
      var bgL = (BG[0] + BG[1] + BG[2]) / 3;
      if (cast <= TOL_CAST && Math.abs(lm - bgL) <= TOL_LUM && !GRADE) return null;
      return { kind: 'product', g: avg.map(function (v, k) {
        return Math.round(clamp(PRE[k] / (v / 255), MIN, MAX) * 1000) / 1000;
      }) };
    }
    // 背景のある写真：暗すぎ／明るすぎ／色かぶりが強いときだけ
    var mean = all / cnt;
    var exp = 1;
    if (mean < SCENE_MIN) exp = clamp(Math.pow(SCENE_MIN / Math.max(mean, 0.05), 0.7), 1, 1.3);
    if (mean > SCENE_MAX) exp = clamp(Math.pow(SCENE_MAX / mean, 0.7), 0.88, 1);
    var castG = [1, 1, 1];
    if (nn > cnt * 0.04) {
      var na = neu.map(function (v) { return v / nn; });
      var gray = (na[0] + na[1] + na[2]) / 3;
      var dev = (Math.max.apply(null, na) - Math.min.apply(null, na));
      if (dev > SCENE_CAST) castG = na.map(function (v) { return 1 + (gray / v - 1) * CAST; });
    }
    if (exp === 1 && castG[0] === 1 && castG[1] === 1 && castG[2] === 1 && !GRADE) return null;
    return { kind: 'scene', g: castG.map(function (c) { return Math.round(clamp(c * exp, 0.8, 1.35) * 1000) / 1000; }) };
  }

  function measure(base, done) {
    if (cache[base] !== undefined) {
      if (cache[base] && cache[base].then) cache[base].then(done); else done(cache[base]);
      return;
    }
    cache[base] = new Promise(function (resolve) {
      var t = new Image();
      t.crossOrigin = 'anonymous';
      t.onload = function () {
        var res = null;
        try {
          var W = t.naturalWidth, H = t.naturalHeight;
          var c = document.createElement('canvas');
          c.width = W; c.height = H;
          var x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(t, 0, 0);
          res = analyze(x.getImageData(0, 0, W, H).data, W, H);
        } catch (e) { res = null; }
        cache[base] = res;
        resolve(res);
      };
      t.onerror = function () { cache[base] = null; resolve(null); };
      t.src = base + '?width=96';
    });
    cache[base].then(done);
  }

  function handle(img) {
    if (img.dataset.ksvTone) return;
    img.dataset.ksvTone = '1';
    var base = baseOf(img.currentSrc || img.src);
    if (!base) return;
    measure(base, function (res) { apply(img, res); });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { io.unobserve(e.target); handle(e.target); }
    });
  }, { rootMargin: '300px 0px' }) : null;

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (img) {
      if (img.dataset.ksvTone || img.dataset.ksvWatch) return;
      img.dataset.ksvWatch = '1';
      if (io) io.observe(img); else handle(img);
    });
  }

  function start() {
    scan(document);
    new MutationObserver(function (list) {
      list.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
